(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('clases', {
            parent: 'app',
            url: '/clases?page&sort&search&type',
            data: {
            	authorities: ['RESPONSABLE_SIDE','ADMINISTRATIVO_GENERAL_SIDE','ADMINISTRATIVO_BACHILLERATO_SIDE'],
                pageTitle: 'Administrar clases'
            },
            views: {
                'content@': {
                    templateUrl: 'app/clases/listadoclases.html',
                    controller: 'ClasesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                type: '1',
                indice : '1',
                ic: false,
                iic: '0',
                anio: '0',
                aniostr: '',
                modelo: '0',
                nivel: '0',
                centro: '0',
                ep: false
                
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        type: $stateParams.type,
                        indice: $stateParams.indice,
                        ic: $stateParams.ic,
                        iic: $stateParams.iic,
                        anio: $stateParams.anio,
                        aniostr: $stateParams.aniostr,
                        modelo: $stateParams.modelo,
                        nivel: $stateParams.nivel,
                        centro: $stateParams.centro,
                        ep: $stateParams.ep
                    };
                }]
            }
        })
        .state('clases.ambito', {
            parent: 'clases',
            url: '/clases/{id}/{idp}/{tiponivel}/{tipomodelo}/{idins}',
            data: {
            	authorities: ['RESPONSABLE_SIDE','ADMINISTRATIVO_GENERAL_SIDE','ADMINISTRATIVO_BACHILLERATO_SIDE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/ambito/crearambito.html',
                    controller: 'AmbitoController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ClasesAmbitoService', function(ClasesAmbitoService) {
                        	return ClasesAmbitoService.obtener({id : $stateParams.id , idp : $stateParams.idp, tiponivel : $stateParams.tiponivel, tipomodelo : $stateParams.tipomodelo, idins :$stateParams.idins}).$promise;
                
                        }]
                    }
                }).result.then(function() {
                    $state.go('clases', null, { reload: 'clases' });
                }, function() {
                    $state.go('clases');
                });
            }]
        })
        .state('downloadPage', {
            parent: 'clases',
            url: '/downloadPage/{ambito}',
            data: {
            	authorities: ['RESPONSABLE_SIDE','ADMINISTRATIVO_GENERAL_SIDE','ADMINISTRATIVO_BACHILLERATO_SIDE'],
                pageTitle: 'Descargar reporte de alumnos evaluados'
            },
            views: {
                'content@': {
                    templateUrl: 'app/descargas/downloadpage.html',
                    controller: 'downloadfilecontroller',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                idambito: '$stateParams.ambito'
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
    }
})();
